<template>
<div class="trader-report">
  <div class="nav-bar">
    <div class="nav-item"
      v-for="(item,index) in barList"
         :key="index"
         :class="{
           on: item.routerName == $route.name
         }"
         @click="navHandle(item)"
    >{{item.label}}</div>
  </div>
  <div class="report-home-content">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
export default {
  name: "index",
  data() {
    let _this = this;
    return {
      barList: [
        {label: _this.$t('Position'), routerName: 'positionOrder'},
        {label: _this.$t('pending_order'), routerName: 'pendingOrder'},
        {label: _this.$t('Transaction_history'), routerName: 'traderHistory'},
      ]
    }
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    navHandle(item) {
      this.$router.push({name: item.routerName});
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.trader-report {
  .nav-bar {

    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .nav-item {
      margin-left: 20px;
      font-size: 14px;
      color: #5E5873;
      height: 100%;
      line-height: 54px;
      cursor: pointer;
      &.on {
        color: $themeColor;
        border-bottom: 2px solid $themeColor;
      }
    }
  }
  .report-home-content {
    padding: 24px;
  }
}
</style>
<style lang="scss">
.trader-report {
  .profit {
    color: #11AC80;
    &.on {
      color: #E74B3A;
    }
  }
  .vs-con-table {
    min-width: 1200px;
  }
  .content-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .header-item {
      margin: 0 5px 10px 5px;
    }
  }
}
</style>
